import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/auth.service';
import { Shimmer } from './shared/shimmer';
import { ToastHost } from './shared/toast-host';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Shimmer, ToastHost],
  template: `
    @if (auth.hydrating()) {
      <app-shimmer variant="boot" />
    } @else {
      <router-outlet />
    }
    <app-toast-host />
  `,
  styles: `
    :host {
      display: block;
      height: 100%;
      min-height: 100dvh;
    }
  `,
})
export class App {
  readonly auth = inject(AuthService);
}
